exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0ac55116] .el-card__body,[data-v-0ac55116] .el-tabs{height:100%}[data-v-0ac55116] .el-tabs__content{height:calc(100% - 54px)!important;position:inherit}[data-v-0ac55116] .el-tabs__content .el-tab-pane{height:100%}", ""]);

// exports
